<mat-dialog-content id="editPayment">
  <div class="flex flex-col gap-2">
    <span class="f-s-20">{{payment.id > 0? 'Edit' : 'Add'}} Payment</span>
    <form [formGroup]="paymentForm" (ngSubmit)="savePayment()">
      <div class="flex flex-col gap-2 md:gap-4">

        <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
          <mat-form-field class="md:w-1/3">
            <mat-label>Payment Type</mat-label>
            <mat-select formControlName="feeType" (selectionChange)="onChangePaymentType()">
              <mat-option>-- None --</mat-option>
              <mat-option *ngFor="let option of this.paymentService.paymentOptions" value={{option.description}}>{{option.description}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentForm.get('feeType')?.invalid">
              Please enter a type
            </mat-error>
          </mat-form-field>

          <mat-form-field class="md:w-1/3">
            <mat-label>Payment Status</mat-label>
            <mat-select formControlName="status">
              <mat-option>-- None --</mat-option>
              <mat-option *ngFor="let option of paymentService.paymentStatuses" value={{option}}>{{option}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentForm.get('status')?.invalid">
              Please enter a payment status
            </mat-error>
          </mat-form-field>

          <mat-form-field class="md:w-1/3">
            <mat-label>SKU</mat-label>
            <input matInput type="text" formControlName="sku"
                   placeholder="SKU"
                   inputmode="text"
                   autocomplete="off"
                   spellcheck="false"/>
            <mat-error *ngIf="paymentForm.get('sku')?.invalid">
              Please enter a SKU
            </mat-error>
          </mat-form-field>

        </div>

        <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
          <mat-form-field class="md:w-1/3">
            <mat-label>Payment Method</mat-label>
            <mat-select formControlName="paymentMethod">
              <mat-option>-- None --</mat-option>
              <mat-option *ngFor="let option of paymentService.paymentMethods" value={{option}}>{{option}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="paymentForm.get('paymentMethod')?.invalid">
              Please choose payment method
            </mat-error>
          </mat-form-field>

          <mat-form-field class="md:w-1/3">
            <mat-label>Amount</mat-label>
            <span matTextPrefix>$&nbsp;</span>
            <input matInput type="text" formControlName="amount"
                   placeholder="0.00"
                   inputmode="decimal"
                   autocomplete="off"
                   spellcheck="false"
                   (keydown)="onAmountKeyDown($event)"
                   (paste)="onAmountPaste($event)"
                   (input)="onAmountInput($event)"
                   (blur)="onAmountBlur($event)"/>
            <mat-error *ngIf="paymentForm.get('amount')?.invalid">
              Please enter an amount
            </mat-error>
          </mat-form-field>

          <mat-form-field class="md:w-1/3">
            <mat-label>Payment Cleared </mat-label>
            <input formControlName="paymentCleared" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="datepickerPaymentCleared"
                   [max]="today" />
            <mat-datepicker-toggle matSuffix [for]="datepickerPaymentCleared"></mat-datepicker-toggle>
            <mat-datepicker #datepickerPaymentCleared>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
        </div>

        <mat-form-field>
          <textarea formControlName="comment" matInput rows="5" placeholder="Comments" type="text">
          </textarea>
          <mat-error *ngIf="paymentForm.get('comment')?.invalid">
            Please enter comments
          </mat-error>
        </mat-form-field>

        <div class="flex flex-row gap-4 portal-actions">
          <button *ngIf="paymentForm.valid && (paymentForm.get('paymentCleared')?.value || today) <= today" mat-button type="button" color="primary" [disabled]="processing"
            (click)="savePayment()">Save
          </button>
          <button mat-button type="button" color="warn" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
